import PdfIcon from '../../../assests/img/pdf.svg?url';
import DocIcon from '../../../assests/img/doc.svg?url';
import ExcelIcon from '../../../assests/img/xls.svg?url';
import UnknownFormatIcon from '../../../assests/img/unknown-format.png?url';


export default function getFileIcon (fileName: string) {
    const nameSplit = fileName.split(".");
    const extn = nameSplit[nameSplit.length-1];
    switch (extn) {
        case 'pdf': return PdfIcon;
        case 'doc':
        case 'docx': return DocIcon;
        case 'xls':
        case 'xlsx':
        case 'xlsm': return ExcelIcon;
        default: return UnknownFormatIcon;
    }
}
